<div class="compass-slide-toggle">
    <mat-slide-toggle [color]="setup.color" [checked]="setup.checked" [disabled]="setup.disabled" [id]="setup.id"
        [disableRipple]="setup.disableRipple" [labelPosition]="setup.labelPosition" [name]="setup.name"
        [required]="setup.required" (change)="emitToggle($event)">
        <span>{{ setup.placeholder.on }}</span>
    </mat-slide-toggle>
</div>